import { useState } from 'react';

export const AccountTypeSelector = ({ onSelectType }) => {
  const [selectedType, setSelectedType] = useState(null);

  const handleContinue = () => {
    if (selectedType) onSelectType(selectedType);
  };

  return (
    <div className="tier-step">
      <div className="step-header">
        <h2>Welcome to Slipstream</h2>
        <p>Let&apos;s get you started. What type of account would you like to create?</p>
      </div>

      <div className="tier-grid tier-grid--2" role="radiogroup" aria-label="Account type">
        <button
          type="button"
          role="radio"
          aria-checked={selectedType === 'company'}
          className={`tier-card${selectedType === 'company' ? ' tier-card--selected' : ''}`}
          onClick={() => setSelectedType('company')}
        >
          <input
            type="radio"
            className="tier-card-input"
            name="account-type"
            checked={selectedType === 'company'}
            readOnly
            tabIndex={-1}
            aria-hidden="true"
          />
          <div className="tier-card-body">
            <span className="tier-card-title">Create a company account</span>
            <span className="tier-card-blurb">Set up Slipstream for your company and integrate your systems.</span>
          </div>
        </button>

        <button
          type="button"
          role="radio"
          aria-checked={selectedType === 'team'}
          className={`tier-card${selectedType === 'team' ? ' tier-card--selected' : ''}`}
          onClick={() => setSelectedType('team')}
        >
          <input
            type="radio"
            className="tier-card-input"
            name="account-type"
            checked={selectedType === 'team'}
            readOnly
            tabIndex={-1}
            aria-hidden="true"
          />
          <div className="tier-card-body">
            <span className="tier-card-title">Join my team</span>
            <span className="tier-card-blurb">My company is already on Slipstream and I&apos;m joining the team.</span>
          </div>
        </button>
      </div>

      <div className="step-nav step-nav--no-top-rule">
        <div />
        <button
          type="button"
          onClick={handleContinue}
          className="btn btn-primary"
          disabled={!selectedType}
        >
          Continue
        </button>
      </div>
    </div>
  );
};
